import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Modal,
  Card,
  CardHeader,
  Table,
  Button,
  Input,
  Label
} from "reactstrap";
import DetailedOrderCard from "../../components/DetailedOrderCard/DetailedOrderCard";
import RequestManager from "../../singletons/RequestManager/RequestManager";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";
import { SDK_CHROME } from "../../config/Constants";
import LoadingOverlay from "react-loading-overlay";
import config from "../../config";
import {
  generateHeaders,
  generateHeaderswithBasicAuthToken,
  generateEpochTimestamp,
  generateSignature
} from "../../utils/helper";

export default class CashOrderReconHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      storeInformation: null,
      startDate: moment().endOf("day"),
      endDate: moment().endOf("day"),
      bookingStartDate: moment().endOf("day"),
      bookingEndDate: moment().endOf("day"),
      pageText: "Your past orders",
      printSdkType: "",
      bookingDateSelected: false,
      spinnerLoading: false,

      // ▼ New state for stores dropdown
      subStores: [], // [{code, name}]
      store_code_filter: "All Stores", // default option
      // ▼ Cashier filter
      cashiers: [],
      cashier_filter: "All Cashiers"
    };
  }

  componentWillMount() {
    this.checkLoginMode();
  }

  async componentDidMount() {
   
    await this.get_sub_stores();       // ▼ fetch stores first
    this.getOrders();             // ▼ then load orders
  }

  checkLoginMode = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "merchant") {
      this.setState({
        storeInformation: storeInformation,
        pageText: "Your Order Summary"
      });
    } else {
      this.setState({ storeInformation: storeInformation });
    }
  };

get_sub_stores = async () => {
    console.log('inside get_sub_stores')
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    var vtimestamp = generateEpochTimestamp();
    // region_name
    try {
      let response = await fetch(
        config.getHost() + "/product/getsubstoresapi/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)               
          },
          body: JSON.stringify({
            store_id: storeInformation.store.id,
            graphql:true
          }),
        }
      );
      
      if (response.status === 200) {
        let json = await response.json();
        // let res = json.results;
        let res = [];
        if (json.results && Array.isArray(json.results) && json.results.length > 0) {
            if (Array.isArray(json.results[0]) && json.results[0].length > 0) {
                res = json.results[0][0]; // This assumes the expected structure
            }
        }
        console.log("res", res);  // Normalize to {code, name}
     

        this.setState(
           { subStores: res,loading:true }
       );

      }   
    } catch (error) {
      console.log("error", error);
    }
  };


  // ▼ Fetch list of stores for dropdown
  getStores_old = async () => {
    try {
      const storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
      const authToken = storeInformation.token;
      const vtimestamp = generateEpochTimestamp();

      // Adjust this endpoint to your actual REST path that returns [{store_code, store_name}]
      const resp = await fetch(config.getHost() + "/product/getsubstoreapi/", {
        method: "POST",
        headers: {
          Authorization: `Token ${authToken}`,
          "Content-Type": "application/json",
          Timestamp: vtimestamp,
          Signature: generateSignature(vtimestamp, authToken)
        },
        body: JSON.stringify({
          // If your API needs scoping, include these:
          store_id: storeInformation.store.id,
          graphql: true

        })
      });

      if (resp.status !== 200) return;

      const data = await resp.json();

      // Accept a few possible shapes safely:
      // 1) { stores: [{store_code, store_name}, ...] }
      // 2) [{store_code, store_name}, ...]
      // 3) { data: { stores: [...] } }
      let raw = [];
      if (Array.isArray(data)) raw = data;
      else if (Array.isArray(data.stores)) raw = data.stores;
      else if (Array.isArray(data.data.stores)) raw = data.data.stores;

      // Normalize to {code, name}
      const stores = (raw || []).map((s) => ({
        code: s.store_code || s.code || s.reference_store_code || "",
        name: s.store_name || s.name || ""
      })).filter(s => s.code);

      // Prepend "All Stores"
      this.setState({
        stores: [{ code: "All Stores", name: "" }, ...stores]
      });
    } catch (e) {
      // Silent fail to keep UI usable
      console.error("getStores error:", e);
      this.setState({
        stores: [{ code: "All Stores", name: "" }]
      });
    }
  };

  handleStartDateChange = (date) => {
    this.setState({ startDate: date });
  };

  handleEndDateChange = (date) => {
    if (
      Date.parse(this.state.startDate.format("MM/DD/YYYY")) >=
      Date.parse(date.format("MM/DD/YYYY"))
    ) {
      if (
        Date.parse(this.state.startDate.format("MM/DD/YYYY")) ===
        Date.parse(date.format("MM/DD/YYYY"))
      ) {
        this.setState({ endDate: date });
      } else {
        alert("End date should be greater than Start date");
      }
    } else {
      this.setState({ endDate: date });
    }
  };

  // ▼ Handle dropdown change
  handleStoreChange = (e) => {
    const val = e.target.value;
    this.setState({ store_code_filter: val });
  };

  handleCashierChange = (e) => {
  this.setState({
    cashier_filter: e.target.value
  });
};

getFilteredOrders = () => {
  const { orders, cashier_filter } = this.state;

  if (
    cashier_filter === "All Cashiers" ||
    cashier_filter === "" ||
    cashier_filter == null
  ) {
    return orders;
  }

  return orders.filter((order) => {
    return String(order.cashier_name || "").trim() === cashier_filter;
  });
};

getFilteredGrandTotal = () => {
  const filteredOrders = this.getFilteredOrders();

  let total = 0;

  filteredOrders.forEach((order) => {
    total += Number(order.order_total || 0);
  });

  return total.toFixed(2);
};


  getOrders = async () => {
    this.setState({
         orders: [],
          grandTotal: 0
        });
    // this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let loginMode = localStorage.getItem("loginMode");
    let params = {};
    if (loginMode === "store") {
      params = { storeId: storeInformation.store.id };
    } else if (loginMode === "merchant") {
      params = { merchantId: storeInformation.merchant.id };
    }

    let date = "";
    let startdate = "";
    let enddate = "";

    if (this.state.startDate !== null) {
      date = this.state.startDate.format("YYYY-MM-DDT");
      date = date + "00:00:00+05:30";
      params.createdAt_Gte = date;
      startdate = date;
    }
    if (this.state.endDate !== null) {
      params.createdAt_Lte = this.state.endDate.format();
      enddate = this.state.endDate.format();
    }

    const authToken = storeInformation.token;
    const vtimestamp = generateEpochTimestamp();

    // ▼ Respect "All Stores" by sending empty string (or omit if your API expects that)
    const selectedStoreCode =
      this.state.store_code_filter === "All Stores"
        ? ""
        : this.state.store_code_filter;

    let response = await fetch(config.getHost() + "/order/getcashreconorders/", {
      method: "POST",
      headers: {
        Authorization: `Token ${authToken}`,
        "Content-Type": "application/json",
        Timestamp: vtimestamp,
        Signature: generateSignature(vtimestamp, authToken)
      },
      body: JSON.stringify({
        foodcourt_id: storeInformation.store.id,
        graphql: true,
        startdate: startdate,
        enddate: enddate,
        // ▼ fixed: was using undefined `store_code`
        store_code: selectedStoreCode
      })
    });

    if (response.status === 200) {
      const jsonres = await response.json();
      console.log('jsonres', jsonres);
      if (jsonres && jsonres !== null) {
        let grandTotal = 0.0;
        const edges = jsonres.data || [];
        for (let i = 0; i < edges.length; i++) {
          {
            grandTotal = grandTotal + edges[i].order_total;
          }
        }

        // Get distinct cashier names
        const cashiers = [];

        edges.forEach((order) => {
          const cashierName = String(order.cashier_name || "").trim();

          if (
            cashierName !== "" &&
            cashiers.indexOf(cashierName) === -1
          ) {
            cashiers.push(cashierName);
          }
        });

        // Optional alphabetical order
        cashiers.sort();

        this.setState({
          spinnerLoading: false,
          orders: edges,
          grandTotal: grandTotal.toFixed(2),
          cashiers: cashiers,
          cashier_filter: "All Cashiers"
        });
      }
    } else {
      this.setState({ spinnerLoading: false });
    }
  };

  getCSVData = () => {
  let startdate = this.state.startDate.format("YYYY-MM-DD");
  let enddate = this.state.endDate.format("YYYY-MM-DD");

  const filteredOrders = this.getFilteredOrders();

  let grandTotal = 0;

  filteredOrders.forEach((order) => {
    grandTotal += Number(order.order_total || 0);
  });

  let csvData = [
    [this.state.pageText],
    [
      "Grand Total",
      "Start Date",
      "End Date",
      "Store Filter",
      "Cashier Filter"
    ],
    [
      grandTotal.toFixed(2),
      startdate,
      enddate,
      this.state.store_code_filter,
      this.state.cashier_filter
    ],
    [""],
    [""],
    [
      "StoreCode Filter",
      "Cashier Filter",
      "Order Id",
      "Order Amount",
      "Status",
      "Store_code",
      "Store_Name",
      "Cashier Name",
      "Collected/Refunded",
      "DateTime"
    ]
  ];

  filteredOrders.map((order) => {
    csvData.push([
      this.state.store_code_filter,
      this.state.cashier_filter,
      order.order_id,
      order.order_total,
      order.order_status,
      order.store_code,
      order.store_name,
      order.cashier_name,
      order.cash_status,
      moment(order.updated_on).format(
        "MMMM Do YYYY, h:mm a"
      )
    ]);

    return order;
  });

  return csvData;
};

  
  render() {
    // , stores, store_code_filter
    const { spinnerLoading } = this.state;
  const filteredOrders = this.getFilteredOrders();
  const filteredGrandTotal = this.getFilteredGrandTotal();
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container fluid style={{ padding: 0, margin: 0 }}>
          <Row noGutters>
            <Col>
              <Card>
                <CardHeader>
                  <Container fluid>
                    <Row>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{this.state.pageText}</h5>
                      </Col>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>
                          {/* {" Grand Total= " + this.state.grandTotal} */}
                           {" Grand Total= " + filteredGrandTotal}
                        </h5>
                      </Col>

                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5 style={{ marginRight: "10px" }}>
                          {/* {"Total Orders: " + this.state.orders.length} */}
                           {"Total Orders: " + filteredOrders.length}
                        </h5>
                      </Col>
                    </Row>

{/* Search row */}
<Row
  style={{
    alignItems: "flex-end",
    marginTop: 10,
    marginBottom: 15
  }}
>
  <Col xs="12" sm="6" md="3" lg="3">
    <Label for="storesDropdown">
      Stores
    </Label>

    <Input
      id="storesDropdown"
      type="select"
      value={this.state.store_code_filter}
      onChange={this.handleStoreChange}
    >
      <option value="">All Stores</option>

      {this.state.subStores.map((store) => {
        return (
          <option
            key={store.storeCode}
            value={store.storeCode}
          >
            {store.storeCode}
          </option>
        );
      })}
    </Input>
  </Col>

  <Col xs="12" sm="6" md="2" lg="2">
    <Label>Start Date</Label>

    <DatePicker
      selected={this.state.startDate}
      maxDate={moment().endOf("day")}
      dateFormat="DD/MM/YYYY"
      onChange={this.handleStartDateChange}
      className="form-control"
    />
  </Col>

  <Col xs="12" sm="6" md="2" lg="2">
    <Label>End Date</Label>

    <DatePicker
      selected={this.state.endDate}
      maxDate={moment().endOf("day")}
      dateFormat="DD/MM/YYYY"
      disabledKeyboardNavigation={true}
      onChange={this.handleEndDateChange}
      className="form-control"
    />
  </Col>

  <Col xs="12" sm="6" md="2" lg="2">
    <Button
      onClick={() => {
        this.getOrders();
      }}
    >
      Submit
    </Button>
  </Col>
</Row>

{/* Client-side filters row */}
<Row
  style={{
    alignItems: "flex-end",
    marginBottom: 10
  }}
>
  <Col xs="12">
    <h6 style={{ marginBottom: 8 }}>
      Filters
    </h6>
  </Col>

  <Col xs="12" sm="6" md="3" lg="3">
    <Label for="cashierDropdown">
      Cashier
    </Label>

    <Input
      id="cashierDropdown"
      type="select"
      value={this.state.cashier_filter}
      onChange={this.handleCashierChange}
    >
      <option value="All Cashiers">
        All Cashiers
      </option>

      {this.state.cashiers.map((cashier) => {
        return (
          <option
            key={cashier}
            value={cashier}
          >
            {cashier}
          </option>
        );
      })}
    </Input>
  </Col>

  <Col xs="12" sm="6" md="2" lg="2">
    <CSVLink
      className="btn btn-primary"
      filename={"CashOrderReconciliationSummary.csv"}
      data={this.getCSVData()}
    >
      Export to CSV
    </CSVLink>
  </Col>
</Row>
                  </Container>
                </CardHeader>

                <Table responsive>
                <tbody key={this.state.cashier_filter}>
                    <tr>
                      <th>Order Id</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Store Code</th>
                      <th>Store Name</th>
                      <th>Cashier</th>
                      <th>Collected/Refunded</th>
                      <th>Date/Time</th>
                    </tr>
                    {/* {this.state.orders.map((order) => { */}
                      {filteredOrders.map((order) => {
                      return (
                        <tr key={order.order_id}>
                          <td>{order.order_id}</td>
                          <td>{"₹" + order.order_total}</td>
                          <td>{order.order_status}</td>
                          <td>{order.store_code}</td>
                          <td>{order.store_name}</td>
                          <td>{order.cashier_name}</td>
                          <td>{order.cash_status}</td>
                          <td>
                            {order.updated_on !== null
                              ? moment(order.updated_on).format(
                                  "MMMM Do YYYY, h:mm a"
                                )
                              : null}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </LoadingOverlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/OrderHistory/CashOrderReconHistory.js